

















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'QuestionList'
})
export default class extends Vue {
  @Prop({
    required: true
  })
  list!: Array<any>
  //list: Array<HelpClassList> = []

  async handleItem(item: HelpClassList) {
    this.$point.clickReport({
      pageId: 'page_h5_help_feedback',
      eventId: 'HelpFeedbackClassificationBtn',
      eventType: 'liveType',
      targetType: 'liveButton',
      targetName: '帮助和反馈各个问题分类点击'
    })
    if (item.type_id == 1) {
      window.location.href = item.href
      return
    }

    if (item.type_id == 2) {
      this.$router.push(
        `/help-detail?title=${item.title}&id=${item.problem_id}`
      )
    }
  }
}
